<div
  class="sb-field"
  [class.sb-field--disabled]="disabled()"
  [class.sb-field--required]="required()"
  [class.sb-field--help-inside]="showHelpEndInside"
  [class.sb-field--help-outside]="showHelpEndOutside"
  [class.sb-field--has-companions]="hasCompanions">
  @if (label() || showHelpAfterLabel || (!wysiwyg() && hasCompanions)) {
  <div class="sb-field__label-row">
    <label class="mb-0" [attr.for]="id()">
      {{ label() }}
      @if (required()) {
      <span class="red">*</span>
      }
    </label>
    @if (showHelpAfterLabel) {
    <app-info-popover
      class="sb-field__help sb-field__help--after-label"
      [info]="helpText"></app-info-popover>
    }
    @if (!wysiwyg() && hasCompanions) {
    <div class="sb-field__label-actions">
      @if (showFileBrowser()) {
      <app-file-browser
        class="sb-companion-host"
        [clientId]="clientId()"
        [projectId]="projectId()"
        [enableChoose]="true"
        [iconOnly]="true"
        [disabled]="disabled()"
        defaultIcon="fa fa-folder-open"
        (fileSelected)="onFileBrowserSelected($event)">
      </app-file-browser>
      }
      @if (showVariableBrowser()) {
      <app-variables
        class="sb-companion-host"
        [variableClickFor]="resolvedVariableFor"
        [fieldType]="variableFieldType()"
        [format]="variableFormat()"
        [isDisabled]="disabled()"
        [hideText]="true"
        (onVariableClick)="onVariablePicked($event)">
      </app-variables>
      }
      @if (showFontBrowser()) {
      <app-font-browser
        class="sb-companion-host"
        [projectId]="projectId()"
        [iconOnly]="true"
        [disabled]="disabled()"
        (fontSelected)="onFontBrowserSelected($event)">
      </app-font-browser>
      }
      @if (showHelpEndInside) {
      <app-info-popover
        class="sb-field__help sb-companion-info"
        [info]="helpText"></app-info-popover>
      }
    </div>
    }
  </div>
  }
  @if (description()) {
  <div class="sb-field__description">{{ description() }}</div>
  }

  <div
    class="sb-field__control-row"
    [class.sb-field__control-row--with-help]="showHelpEndOutside">
    <div class="sb-field__control" [class.floating-label]="!wysiwyg() && !label()">
      @if (wysiwyg()) {
        <div class="sb-field__wysiwyg" [attr.aria-required]="required()">
          <app-sb-rich-text
            #richText
            [html]="value"
            [tools]="richTextTools"
            [readOnly]="disabled()"
            [height]="autoExpandEnabled ? 120 : 180"
            [autoGrow]="autoExpandEnabled"
            [resizable]="!autoExpandEnabled"
            [imageBrowse]="showFileBrowser()"
            [ariaLabel]="label()"
            (htmlChange)="onEditorChange($event)"
            (blurred)="onBlur()"
            (variableRequest)="openVariables()"
            (fontBrowserRequest)="openFontBrowser()"
            (imageBrowseRequest)="openImageBrowser()">
          </app-sb-rich-text>
        </div>

        <div class="sb-wysiwyg-hosts">
          @if (showFileBrowser()) {
          <app-file-browser
            #fileBrowser
            [clientId]="clientId()"
            [projectId]="projectId()"
            [enableChoose]="true"
            [iconOnly]="true"
            [disabled]="disabled()"
            (fileSelected)="onFileBrowserSelected($event)">
          </app-file-browser>
          }
          @if (showVariableBrowser()) {
          <app-variables
            #variablesBtn
            [variableClickFor]="resolvedVariableFor"
            [fieldType]="variableFieldType()"
            [format]="variableFormat()"
            [isDisabled]="disabled()"
            [hideText]="true"
            (onVariableClick)="onVariablePicked($event)">
          </app-variables>
          }
          @if (showFontBrowser()) {
          <app-font-browser
            #fontBrowser
            [projectId]="projectId()"
            [iconOnly]="true"
            [disabled]="disabled()"
            (fontSelected)="onFontBrowserSelected($event)">
          </app-font-browser>
          }
        </div>

        @if (showHelpEndInside && wysiwyg()) {
        <app-info-popover
          class="sb-field__help sb-field__help--end-inside"
          [info]="helpText"></app-info-popover>
        }
      } @else {
        <textarea
          #plainArea
          class="floating-input floating-textarea"
          [class.floating-placeholder]="useFloatingPlaceholder"
          [class.sb-textarea--fixed]="!autoExpandEnabled"
          [id]="id()"
          [placeholder]="inputPlaceholder"
          [disabled]="disabled()"
          [required]="required()"
          [attr.aria-required]="required()"
          [rows]="rows()"
          [value]="value"
          (input)="onPlainInput($event)"
          (blur)="onBlur()"></textarea>
        @if (!label()) {
        <label [for]="id()">
          @if (required()) {
          <span class="red">*</span>
          }
          @if (showHelpAfterLabel) {
          <app-info-popover
            class="sb-field__help sb-field__help--after-label"
            [info]="helpText"></app-info-popover>
          }
        </label>
        }
        @if (showHelpEndInside && !hasCompanions) {
        <app-info-popover
          class="sb-field__help sb-field__help--end-inside"
          [info]="helpText"></app-info-popover>
        }
      }


      @if (error()) {
      <div class="bar error-brd sb-field__error">
        <div class="invalid-text">{{ error() }}</div>
      </div>
      }
    </div>
    @if (showHelpEndOutside) {
    <app-info-popover
      class="sb-field__help sb-field__help--end-outside"
      [info]="helpText"></app-info-popover>
    }
  </div>
</div>
